<template>
  <cadastro-base
    :salvar="salvar"
    :cancelar="cancelar"
  >
    <template slot="conteudo">
      <div slot="modal-title">
        <h5>Datas de atualizações das rotinas</h5>
        <fieldset class="font-weight-bold text-muted">
          Nos informe quais dias do mês deseja que o sistema faça a atualização das rotinas automáticas.
        </fieldset>
        <hr
          class="mx-0 mt-0 mb-2"
          style="border-top: 1px solid #a3a4a66b !important;"
        >
      </div>
      <div>
        <b-row>
          <b-col cols="12">
            <h5>CERTIDÕES</h5>
            <feather-icon
              v-b-tooltip.hover
              icon="InfoIcon"
              size="12"
              style="position: absolute; top: 3px; left: 110px"
              :title="mensagemPadrao"
            />
          </b-col>
        </b-row>
        <b-row style="margin-top: 1%;">
          <b-col cols="auto">
            <b-form-group
              label="RFB/PGFN"
              label-for="diaRfbPgfnInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="RFB/PGFN"
              >
                <b-input
                  id="diaRfbPgfnInput"
                  v-model="form.diaRfbPgfn"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaRfbPgfn')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="auto">
            <b-form-group
              label="FGTS"
              label-for="diaFgtsInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="FGTS"
              >
                <b-input
                  id="diaFgtsInput"
                  v-model="form.diaFgts"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaFgts')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->
          <b-col cols="auto">
            <b-form-group
              label="MTE"
              label-for="diaMteInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="MTE"
              >
                <b-input
                  id="diaMteInput"
                  v-model="form.diaMte"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaMte')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="auto">
            <b-form-group
              label="Trabalhista"
              label-for="diaTrabalhistaInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="Trabalhista"
              >
                <b-input
                  id="diaTrabalhistaInput"
                  v-model="form.diaTrabalhista"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaTrabalhista')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="auto">
            <b-form-group
              label="Estadual"
              label-for="diaEstadualInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="Estadual"
              >
                <b-input
                  id="diaEstadualInput"
                  v-model="form.diaEstadual"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaEstadual')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="auto">
            <b-form-group
              label="Municipal"
              label-for="diaMunicipalInput"
            >
              <validation-provider
                #default="{ errors }"
                rules="diaValido"
                name="Municipal"
              >
                <b-input
                  id="diaMunicipalInput"
                  v-model="form.diaMunicipal"
                  type="number"
                  placeholder="Dia da consulta"
                  :disabled="bloqueio"
                  @blur="formatarNumero('diaMunicipal')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <fieldset
        style="margin-top: 10px;"
        class="font-weight-bold text-muted"
      >
        FGTS será atualizada conforme a data do seu vencimento.
      </fieldset>
      <div style="margin-top: 5px; margin-block-end: 50px;">
        <fieldset
          v-if="!bloqueio"
          class="font-weight-bold text-muted"
        >
          Ao salvar o cadastro, essa tela ficará bloqueada para alterações temporariamente. As parametrizações só podem ser refeitas após 30 dias!
        </fieldset>
        <fieldset
          v-else
          class="font-weight-bold"
          style="color: #ea5455;"
        >
          Os campos encontram-se bloqueados para alterações até dia {{ form.dataBloqueio }}.
        </fieldset>
      </div>
    </template>
  </cadastro-base>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { diaValido } from '@pilar/plugins/p-validation/p-validation'
import api from './shared/services/api'

export default {
  name: 'ParametroSistema',
  components: {
    ValidationProvider,
    CadastroBase: () => import('@pilar/components/cadastro-base/CadastroBase.vue'),
  },
  data() {
    return {
      form: { },
      diaValido,
      bloqueio: false,
      mensagemPadrao: 'Caso nenhuma data seja informada o sistema considera dia 15 para execução das rotinas.',
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    formatarNumero(campo) {
      if (this.form[campo] && +this.form[campo] < 10) {
        this.form[campo] = `0${+this.form[campo]}`
      }
    },
    adicionarZero(numero) {
      return numero < 10 ? `0${numero}` : `${!numero ? '' : numero}`
    },
    carregar() {
      api.get().then(payload => {
        this.form = payload.data
        this.form.diaRfbPgfn = this.adicionarZero(this.form.diaRfbPgfn)
        this.form.diaFgts = this.adicionarZero(this.form.diaFgts)
        this.form.diaMte = this.adicionarZero(this.form.diaMte)
        this.form.diaTrabalhista = this.adicionarZero(this.form.diaTrabalhista)
        this.form.diaEstadual = this.adicionarZero(this.form.diaEstadual)
        this.form.diaMunicipal = this.adicionarZero(this.form.diaMunicipal)
        this.bloqueio = this.campoBloqueio()
      }).catch(err => {
        throw err
      })
    },
    campoBloqueio() {
      if (this.form.dataBloqueio) {
        const partes = this.form.dataBloqueio.split('/')
        const dataBloqueio = new Date(`${partes[1]}/${partes[0]}/${partes[2]}`)
        const trintaDiasDepois = new Date(dataBloqueio)

        const hoje = new Date()
        return hoje < trintaDiasDepois
      }
      return false
    },
    cancelar() {
      this.$router.push({ name: 'dashboard-analitico' })
    },
    salvar() {
      if (this.bloqueio) {
        this.$erro(`Não foi possível salvar as alterações. Parâmetros bloqueados até ${this.form.dataBloqueio}`, 'danger')
        return null
      }

      return new Promise((resolve, reject) => {
        api.salvar(this.form)
          .then(payload => {
            this.form = payload.data
            this.carregar()
            const acao = this.form.dataBloqueio !== undefined ? 'alterado' : 'cadastrado'
            resolve(`Parâmetros do sistema ${acao} com sucesso`)
          })
          .catch(error => {
            reject(error.response.data.message)
          })
        return this.form
      })
    },
  },
}
</script>
